import { render, staticRenderFns } from "./tagsAll.vue?vue&type=template&id=4475dd52&scoped=true"
import script from "./tagsAll.vue?vue&type=script&lang=ts"
export * from "./tagsAll.vue?vue&type=script&lang=ts"
import style0 from "./tagsAll.vue?vue&type=style&index=0&id=4475dd52&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475dd52",
  null
  
)

/* custom blocks */
import block0 from "./tagsAll.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports